import { z } from "zod";

export const profileStepOneSchema = z.object({
  full_name: z
    .string()
    .trim()
    .min(2, { message: "Name must be at least 2 characters" })
    .max(100, { message: "Name must be less than 100 characters" }),
  phone: z
    .string()
    .trim()
    .regex(/^(\+44|0)[0-9]{10}$/, { message: "Please enter a valid UK phone number" })
    .optional()
    .or(z.literal("")),
  location_city: z
    .string()
    .trim()
    .min(2, { message: "Location must be at least 2 characters" })
    .max(100, { message: "Location must be less than 100 characters" })
    .optional()
    .or(z.literal("")),
  date_of_birth: z.date().refine((date) => {
    const age = new Date().getFullYear() - date.getFullYear();
    return age >= 16 && age <= 100;
  }, { message: "You must be between 16 and 100 years old" }),
});

export const profileStepTwoSchema = z.object({
  bio: z
    .string()
    .trim()
    .min(10, { message: "Bio must be at least 10 characters" })
    .max(500, { message: "Bio must be less than 500 characters" })
    .optional()
    .or(z.literal("")),
  experience_years: z
    .number()
    .int()
    .min(0, { message: "Experience must be 0 or more years" })
    .max(60, { message: "Experience must be less than 60 years" })
    .optional(),
  skills: z
    .array(z.string())
    .min(1, { message: "Please add at least one skill" })
    .max(20, { message: "Maximum 20 skills allowed" }),
});

export const profileStepThreeSchema = z.object({
  linkedin_url: z
    .string()
    .url({ message: "Please enter a valid URL" })
    .optional()
    .or(z.literal("")),
  github_url: z
    .string()
    .url({ message: "Please enter a valid URL" })
    .optional()
    .or(z.literal("")),
  website_url: z
    .string()
    .url({ message: "Please enter a valid URL" })
    .optional()
    .or(z.literal("")),
});

export type ProfileStepOneData = z.infer<typeof profileStepOneSchema>;
export type ProfileStepTwoData = z.infer<typeof profileStepTwoSchema>;
export type ProfileStepThreeData = z.infer<typeof profileStepThreeSchema>;
